import React from 'react'
import './AllStocks.scss'
import {withRouter} from "react-router-dom";
import {MDBBox, MDBIcon, MDBTypography} from "mdbreact";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import StockListQuery from "../../queries/StockListQuery";
import StockList from "../../component/StockListing/StockList";
import Loading from "../../component/Loading";
import FullPageModal from "../../component/FullPageModal/FullPageModal";
import AllPartyQuery from "../../queries/AllPartyQuery";
import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css";
import StockFilterQuery from "../../queries/StockFilterQuery";
import StocksInNewsQuery from "../../queries/StocksInNewsQuery";
import UpcommingStocksQuery from "../../queries/UpcommingStocksQuery";
import UpcommingStocks from "../../component/UpcommingStocks/UpcommingStocks";
import StockSearchQuery from "../../queries/StockSearchQuery";
import AllCollectionsQuery from "../../queries/AllCollectionsQuery";
import {AddFilter, RemoveFilter} from "../../Actions";
import {connect} from "react-redux";
import {Zoom} from 'react-reveal'
import {assetUrl} from "../../serviceApi";
import StockOwnedCountQuery from "../../queries/StockOwnedCountQuery";
import FeaturedStocksInNewsQuery from "../../queries/FeaturedStocksInNewsQuery";
import {NonEmptyArray} from "../../util";
import StockHistoryDetailsQuery from "../../queries/StockHistoryDetailsQuery";

const FilterIcon = assetUrl + "images/filter-icon.svg"
const ArrowLeft = assetUrl + "images/arrow-left.svg";
const SearchIcon = assetUrl + "images/search-icon-white.svg";

class AllStocks extends React.Component {
	state = {
		search_text: "",
		stock_list: [],
		selected_tags: [],
		full_height_modal: false,
		selected_party: {},
		party_list: [],
		short_by: "",
		age_range: {min: 0, max: 0},
		upcomming_stocks: [],
		collections: [],
		selected_collection: {},
		loadingArray: ["loading"],
		stockOwnedCount: {},
		stockHistoryDetails:[]

	}

	componentWillMount() {
		if (this.props.fillter_applied) {
			let applied_filter = this.props.applied_filter;
			this.setState({
				selected_party: applied_filter.party,
				selected_collection: applied_filter.collection,
				age_range: applied_filter.age_range,
				short_by: applied_filter.short_by
			});
		}
	}

	componentDidMount() {
		if (this.props.fillter_applied) {
			this.filterStocks();
		} else {
			this.checkStockType();
		}
		// this.getAllParties();
		this.getAllCollections();
		if(this.props.logged_in){
			this.getStockOwnedCount();
		}
		this.getStockHistoryDetails()

	}

	formateStockData = (response) => {
		let stockList = [];
		let res_data = response;
		for (var i = 0; i < res_data.length; i++) {
			stockList[i] = {
				id: res_data[i].node.id,
				name: res_data[i].node.name,
				party_name: res_data[i].node.party.partyName,
				price: res_data[i].node.price,
				// stockOwned change
				// stocks_owned: res_data[i].node.stockOwnedCount,
				// price_diffrence: res_data[i].node.priceDiff,
				politicianImage: res_data[i].node.politicianImage
			}
		}
		return stockList;
	}

	hangleSearchInput = (e) => {
		this.setState({
			search_text: e.target.value
		}, () => {
			if (e.target.value === "") {
				this.getAllStocks();
			}
		});
	}

	getAllStocks = () => {
		let variables = {}
		this.updateLoading(true);
		fetchQuery(environment, StockListQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.allPoliticians !== null && response.allPoliticians.edges.length > 0) {
					this.setState({
						stock_list: this.formateStockData(response.allPoliticians.edges)
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					},()=>{
						// this.stockOwnedCountMatcher();
					})
					// console.log(response.allPoliticians.edges)
				} else {
					this.setState({
						stock_list: []
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stock_list: []
				})
			});
	}
	getStockHistoryDetails = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockHistoryDetailsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);


				if (  response.stockHistoryDetails !== null && Object.keys(response.stockHistoryDetails).length > 0) {


					this.setState({
						stockHistoryDetails:  response.stockHistoryDetails
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.stockHistoryDetails.price_diff)
				} else {
					this.setState({
						stockHistoryDetails: []

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockHistoryDetails: []
				})
			});
	}
	getStockOwnedCount = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockOwnedCountQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.stockOwnedCount !== null && Object.keys(response.stockOwnedCount).length > 0) {
					this.setState({
						stockOwnedCount: response.stockOwnedCount
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.allPoliticians.edges)
				} else {
					this.setState({
						stockOwnedCount: {}

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockOwnedCount: {}
				})
			});
	}

	getAllCollections = () => {
		let variables = {}
		this.updateLoading(true);
		fetchQuery(environment, AllCollectionsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.allCollections !== null && response.allCollections.edges.length > 0) {
					this.setState({
						collections: response.allCollections.edges
					})
				} else {
					this.setState({
						collections: []
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					collections: []
				})
			});
	}

	getStocksInNews = () => {
		let variables = {}
		this.updateLoading(true);
		fetchQuery(environment, StocksInNewsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (NonEmptyArray(response.allPoliticians)) {
					this.setState({
						stock_list: response.allPoliticians.edges
					})
				} else {
					this.setState({
						stock_list: []
					})
				}

			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stock_list: []
				})
			});
	}

	getUpcommingStocks = () => {
		let variables = {}
		this.updateLoading(true);
		fetchQuery(environment, UpcommingStocksQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.allPoliticians !== null && response.allPoliticians.edges.length > 0) {
					this.setState({
						upcomming_stocks: response.allPoliticians.edges
					})
				} else {
					this.setState({
						upcomming_stocks: []
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					upcomming_stocks: []
				})
			});
	}

	// getAllParties = () => {
	// 	let variable = {};
	// 	this.updateLoading(true);
	// 	fetchQuery(environment, AllPartyQuery, variable)
	// 		.toPromise()
	// 		.then(response => {
	// 			this.updateLoading(false);
	// 			if (response.allParties !== null && response.allParties.edges.length > 0) {
	// 				this.setState({
	// 					party_list: response.allParties.edges
	// 				})
	// 			} else {
	// 				this.setState({
	// 					party_list: []
	// 				})
	// 			}
	// 		}, err => {
	// 			console.log(err);
	// 			this.updateLoading(false);
	// 			this.setState({
	// 				party_list: []
	// 			})
	// 		});
	// }



	removeTag = (i) => {
		let tags = this.state.selected_tags.slice();
		let index = tags.findIndex(x => x.key === i.key);
		if (index !== -1) {

			if (i.key === "selected_party") {
				this.setState({
					selected_party: {}
				})
			}
			if (i.key === "selected_collection") {
				this.setState({
					selected_collection: {}
				})
			}
			if (i.key === "short_by") {
				this.setState({
					short_by: ""
				})
			}
			if (i.key === "age_range") {
				this.setState({
					age_range: {min: 0, max: 0}
				})
			}

			tags.splice(index, 1);
			this.setState({selected_tags: tags}, () => {
				this.filterStocks();
			});

		}
	}

	updateLoading = (action) => {
		let tmp_loading_array = this.state.loadingArray;
		if (action) {
			tmp_loading_array.push("loading");
		} else {
			tmp_loading_array.pop();
		}
		this.setState({
			loadingArray: tmp_loading_array
		})
	}

	openFullHeightModal = () => {
		this.setState({
			full_height_modal: true,
		});
	}

	closeFullHeightModal = () => {
		this.setState({
			full_height_modal: false,
		});
	}

	handlePartyChange = (data, feild) => {
		this.setState({
			[feild]: data
		})
	}

	handleRadioInputs = (value, feild) => {
		this.setState({
			[feild]: value
		});
	}

	handleAgeRange = (value) => {
		this.setState({
			age_range: value
		})
	}

	filterStocks = () => {
		let variable = {};
		let applied_filters = [];
		let filter_obj = {};

		if (Object.keys(this.state.selected_party).length > 0) {
			variable['party'] = this.state.selected_party.id;
			applied_filters.push({key: "selected_party", value: this.state.selected_party.partyName});
			filter_obj['party'] = this.state.selected_party;
		}
		if (Object.keys(this.state.selected_collection).length > 0) {
			variable['collection'] = this.state.selected_collection.id;
			applied_filters.push({key: "selected_collection", value: this.state.selected_collection.name});
			filter_obj['collection'] = this.state.selected_collection;
		}
		if (this.state.short_by !== "") {
			filter_obj['short_by'] = this.state.short_by;

			if (this.state.short_by === "low_to_high" || this.state.short_by === "high_to_low") {
				variable['lowToHigh'] = this.state.short_by === "low_to_high";
				applied_filters.push({
					key: "short_by",
					value: this.state.short_by === "low_to_high" ? "Low To High" : "High To Low"
				});

			} else if (this.state.short_by === "popularity") {
				variable['popularity'] = true;
				applied_filters.push({key: "short_by", value: "popularity"});

			} else if (this.state.short_by === "recommended") {
				variable['recommended'] = true;
				applied_filters.push({key: "short_by", value: "recommended"});

			}
		}
		if (this.state.age_range.min > 0 || this.state.age_range.max > 0) {
			variable['age_Gte'] = this.state.age_range.min;
			variable['age_Lte'] = this.state.age_range.max;
			applied_filters.push({
				key: "age_range",
				value: "Age " + this.state.age_range.min + " < " + this.state.age_range.max
			});
			filter_obj['age_range'] = this.state.age_range;
		}
		if (this.props.match.params.action === "news") {
			variable['isInNews'] = true;
		}
		if (this.props.match.params.action === "upcomming") {
			variable['upcoming'] = true;
		}
		this.setState({
			selected_tags: applied_filters
		})

		this.updateLoading(true);
		fetchQuery(environment, StockFilterQuery, variable)

			.toPromise()
			.then(response => {

				this.closeFullHeightModal();
				this.updateLoading(false);
				this.props.applyFilter(filter_obj);
				if (response.politicianFilter !== null) {
					if (this.props.match.params.action === "upcomming") {
						this.setState({
							upcomming_stocks: response.politicianFilter.edges
						});
					} else {
						this.setState({
							stock_list: this.formateStockData(response.politicianFilter.edges)
						})
					}
				} else {
					this.setState({
						stock_list: []
					})
				}
			}, err => {
				this.closeFullHeightModal();
				this.updateLoading(false);
				console.log(err);
				if (this.props.match.params.action === "upcomming") {
					this.setState({
						upcomming_stocks: [],
					});
				} else {
					this.setState({
						stock_list: [],

					})
				}
			});
	}

	clearFilter = () => {
		this.setState({
			short_by: "",
			age_range: {min: 0, max: 0},
			selected_party: {},
			selected_collection: {}
		}, () => {
			this.checkStockType();
		});

	}

	checkStockType = () => {
		if (this.props.match.params.action === "news") {
			this.getStocksInNews();
		} else if (this.props.match.params.action === "upcomming") {
			this.getUpcommingStocks();
		} else {
			this.getAllStocks();
		}
	}

	searchStocks = () => {
		let variable = {
			name_Icontains: this.state.search_text
		};

		this.updateLoading(true);
		fetchQuery(environment, StockSearchQuery, variable)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.politicianFilter !== null) {
					if (this.props.match.params.action === "upcomming") {
						this.setState({
							upcomming_stocks: response.politicianFilter.edges
						});
					} else {
						this.setState({
							stock_list: this.formateStockData(response.politicianFilter.edges)
						})
					}
				} else {
					this.setState({
						stock_list: []
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				if (this.props.match.params.action === "upcomming") {
					this.setState({
						upcomming_stocks: []
					});
				} else {
					this.setState({
						stock_list: []
					})
				}
			});
	}

	backToPreviousPage = () => {
		this.props.clearFilter()
		this.props.history.goBack()
	}

	render() {
		let page_title = "";
		if (this.props.match.params.action === "news") {
			page_title = "Trending Politicians";
		} else if (this.props.match.params.action === "upcomming") {
			page_title = "Upcoming Stocks";
		} else {
			page_title = "All Stocks";
		}

		return (
			<Loading loading={this.state.loadingArray.length > 1}>
				<div className={"all-stock-list-component "}>
					<div className="header-section d-flex justify-content-between align-items-center ">
						<MDBBox className="d-flex align-items-center">
							<img src={ArrowLeft} alt={"ArrowLeft"} onClick={() => this.backToPreviousPage()}/>
							<MDBTypography tag="h4" className="font-weight-bold title">
								{page_title}
							</MDBTypography>
						</MDBBox>
						<button type={"button"} className={"btn filter-btn"} onClick={this.openFullHeightModal}>
							<img src={FilterIcon} alt={"FilterIcon"} className={"img-fluid mr-1"}/>
							Filter
						</button>
					</div>
					<div className={"stock-list-main"}>
						<div className={"search-section"} style={{marginBottom: "16px"}}>
							<div className="input-group">
								<input type="text" className="form-control"
								       placeholder="Search" value={this.state.search_text}
								       onChange={(e) => this.hangleSearchInput(e)}
								/>
								<div className="input-group-append">
									<button className="btn search-btn" type="button" onClick={this.searchStocks}>
										<img src={SearchIcon} alt={"SearchIcon"}/>
									</button>
								</div>
							</div>
						</div>
						{
							this.state.selected_tags.length > 0 &&
							<div className={"tags-list-section"} style={{marginBottom: "20px"}}>
								<div className="input-tag">
									<Zoom cascade>
										<ul className="input-tag__tags">
											{this.state.selected_tags.map((tag, i) => (
												<li key={i}>
													{tag.value}
													<MDBIcon icon="times" className={"ml-2"} size={"1x"}
													         onClick={() => {
														         this.removeTag(tag);
													         }}/>
												</li>
											))}
										</ul>
									</Zoom>
								</div>
							</div>
						}

						<hr className={"divider"} style={{marginBottom: "20px"}}/>
						<div>
							{
								this.props.match.params.action === "upcomming" ?
									<UpcommingStocks stock_data={this.state.upcomming_stocks}
									Componentloading={this.state.loadingArray.length > 1}/>
									:
									<StockList stock_list={this.state.stock_list}
									           loading={this.state.loadingArray.length > 1}
												stock_history_details = {this.state.stockHistoryDetails}
									           stock_owned_count={this.state.stockOwnedCount}/>

							}
						</div>
					</div>

					<FullPageModal
						setBackground={true}
						title={"Filters"}
						isOpen={this.state.full_height_modal}
						closeModal={this.closeFullHeightModal}>
						<StockFilter
							party_list={this.props.allPartiesFromStore}
							selected_party={this.state.selected_party}
							handlePartyChange={this.handlePartyChange}
							short_by={this.state.short_by}
							handleRadioInputs={this.handleRadioInputs}
							age_range={this.state.age_range}
							handleAgeRange={this.handleAgeRange}
							filterStocks={this.filterStocks}
							clearFilter={this.clearFilter}
							collections={this.state.collections}
							selected_collection={this.state.selected_collection}
						/>
					</FullPageModal>

				</div>
			</Loading>
		)
	}
}

const mapStateToProps = state => ({
	applied_filter: state.FilterReducer.applied_filter,
	fillter_applied: state.FilterReducer.fillter_applied,
	allPartiesFromStore:state.FilterReducer.allParties,
	logged_in: state.UserReducer.logged_in

});

const mapDispatchToProps = dispatch => ({
	applyFilter: data => dispatch(AddFilter(data)),
	clearFilter: () => dispatch(RemoveFilter())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AllStocks));

//stockfilter component
class StockFilter extends React.Component {
	render() {
		const {
			selected_party,
			party_list,
			handlePartyChange,
			short_by,
			handleRadioInputs,
			age_range,
			handleAgeRange,
			filterStocks,
			clearFilter,
			collections,
			selected_collection
		} = this.props;
		return (
			<div>
				<div className={"stock-filter-component pt-4 px-4"}>
					<div>
						<p className={"filter-item-header"}>Parties</p>
						<MDBBox className={"tags-list-section pb-3"}>
							<div className="input-tag">
								<ul className="input-tag__tags">
									{party_list.map((item, index) => (
										<li key={index}
										    className={"party-badge mr-1 " + (selected_party.id === item.node.id ? "active-party" : "")}
										    onClick={() => handlePartyChange(item.node, "selected_party")}
										>
											{item.node.partyName}
										</li>
									))}
								</ul>
							</div>
						</MDBBox>
					</div>
					<div className={"pt-3"}>
						<p className={"filter-item-header"}>Age</p>
						<div className={" px-1"} style={{paddingBottom: "32px"}}>
							<InputRange
								maxValue={100}
								minValue={0}
								value={age_range}
								onChange={(value) => handleAgeRange(value)}
								// onChangeComplete={(value) => console.log(value)}
							/>
						</div>
					</div>
					<div>
						<p className={"filter-item-header"}>Categories</p>
						<MDBBox className={"tags-list-section pb-3"}>
							<div className="input-tag">
								<ul className="input-tag__tags">
									{collections.map((item, index) => (
										<li key={index}
										    className={"party-badge mr-1 " + (selected_collection.id === item.node.id ? "active-party" : "")}
										    onClick={() => handlePartyChange(item.node, "selected_collection")}
										>
											{item.node.name}
										</li>
									))}
								</ul>
							</div>
						</MDBBox>
					</div>
					<div>
						<p className={"filter-item-header pt-3"}>Sorting</p>
						<div className="custom-radio-input-section">
							<ul>
								<li>
									<input type="radio" id="high_to_low" name="selector"
									       checked={short_by === "high_to_low"}
									       onChange={(e) => handleRadioInputs("high_to_low", "short_by")}
									/>
									<label htmlFor="high_to_low">Price-High to Low</label>
									<div className="check"/>
								</li>
								<li>
									<input type="radio" id="low_to_high" name="selector"
									       checked={short_by === "low_to_high"}
									       onChange={(e) => handleRadioInputs("low_to_high", "short_by")}
									/>
									<label htmlFor="low_to_high">Price-Low to High</label>
									<div className="check">
										<div className="inside"/>
									</div>
								</li>
								<li>
									<input type="radio" id="popularity" name="selector"
									       checked={short_by === "popularity"}
									       onChange={(e) => handleRadioInputs("popularity", "short_by")}
									/>
									<label htmlFor="popularity">Popularity</label>
									<div className="check">
										<div className="inside"/>
									</div>
								</li>
								<li>
									<input type="radio" id="recommended" name="selector"
									       checked={short_by === "recommended"}
									       onChange={(e) => handleRadioInputs("recommended", "short_by")}
									/>
									<label htmlFor="recommended">Recommended</label>
									<div className="check">
										<div className="inside"/>
									</div>
								</li>
							</ul>
						</div>
					</div>

				</div>
				<div className={"user-button-card d-flex align-items-center"}>
					{/*<button type={"button"} className={"btn submit-btn outline"} onClick={clearFilter}>*/}
					{/*	Clear Filter*/}
					{/*</button>*/}
					<button type={"button"} className={"btn submit-btn"} onClick={filterStocks}>
						Apply Filters
						<MDBIcon icon="angle-right" className={"ml-2"}/>
					</button>
				</div>
			</div>

		);
	}
}
